import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=245394bd&scoped=true&"
import script from "./Editor.vue?vue&type=script&lang=js&"
export * from "./Editor.vue?vue&type=script&lang=js&"
import style0 from "./Editor.vue?vue&type=style&index=0&id=245394bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245394bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('245394bd')) {
      api.createRecord('245394bd', component.options)
    } else {
      api.reload('245394bd', component.options)
    }
    module.hot.accept("./Editor.vue?vue&type=template&id=245394bd&scoped=true&", function () {
      api.rerender('245394bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/tinymce/Editor.vue"
export default component.exports